import './ContactsTheme.scss';

import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';
import iconWhite from '../assets/ic-contacts-white.svg';

export const ContactsTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-contacts',
    backgroundColor: '#303d4d',
    navbarIcon: iconWhite,
};
